export function MobileCategory({ name }) {
  return <div className="text-white cursor-default font-semibold">{name}</div>;
}

export function MobileItem({ name, dimension }) {
  return (
    <div className="flex items-center justify-between pl-2.5 space-x-2 min-w-0">
      <span className="truncate min-w-0 flex-1">{name}</span>
      <span>{dimension}</span>
    </div>
  );
}
